import { PageHeaderWrapper, ProgressBar } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { IconButton } from "../components/IconButton";

interface CbhWrappedHeaderProps {
  currentStep: number;
  lastInsightIndex: number;
  onNext: () => void;
  onPrevious: () => void;
}

export function CbhWrappedHeader(props: CbhWrappedHeaderProps) {
  const { currentStep, lastInsightIndex, onNext, onPrevious } = props;

  return (
    <PageHeaderWrapper
      sx={(theme) => ({
        position: "absolute",
        top: 0,
        left: theme.spacing(5),
        right: theme.spacing(5),
        zIndex: 1000,
        background: "transparent",
      })}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ gap: 4 }}>
        <IconButton
          size="small"
          iconType="chevron-left"
          variant="outlined"
          disabled={currentStep === 0}
          onClick={onPrevious}
        />
        <ProgressBar completed={currentStep} total={lastInsightIndex} />
        <IconButton
          size="small"
          iconType="chevron-right"
          variant="outlined"
          disabled={currentStep === lastInsightIndex}
          onClick={onNext}
        />
      </Stack>
    </PageHeaderWrapper>
  );
}
